// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rlE0m","content":"styles_content__29WJS","row":"styles_row__18KlC","footer":"styles_footer__1l2Sx","phraseLength":"styles_phraseLength__3eFmj"};